// @ts-nocheck
/* eslint-enable */
// App
import React, { useMemo } from 'react';

// Misc / utils
import * as S from './styles';

// Static base categories - moved outside component for performance
const BASE_BED_CATEGORIES = [
  {
    value: 'anyOrStudio',
    exactDisplay: 'Studio',
    rangeDisplay: 'Any',
    exactAriaLabel: 'Studio',
    rangeAriaLabel: 'Any bedroom configuration',
  },
  {
    value: 'oneOrMore',
    exactDisplay: '1',
    rangeDisplay: '1+',
    exactAriaLabel: '1 bedroom',
    rangeAriaLabel: '1 or more bedrooms',
  },
  {
    value: 'twoOrMore',
    exactDisplay: '2',
    rangeDisplay: '2+',
    exactAriaLabel: '2 bedrooms',
    rangeAriaLabel: '2 or more bedrooms',
  },
  {
    value: 'threeOrMore',
    exactDisplay: '3',
    rangeDisplay: '3+',
    exactAriaLabel: '3 bedrooms',
    rangeAriaLabel: '3 or more bedrooms',
  },
  {
    value: 'fourOrMore',
    exactDisplay: '4',
    rangeDisplay: '4+',
    exactAriaLabel: '4 bedrooms',
    rangeAriaLabel: '4 or more bedrooms',
  },
];

const BedButtons = ({ handleClick, state }) => {
  // Memoize the category data to prevent recreation on every render
  const bedCategories = useMemo(() => {
    return BASE_BED_CATEGORIES.map((bed) => ({
      value: bed.value,
      display: state.isExact ? bed.exactDisplay : bed.rangeDisplay,
      ariaLabel: state.isExact ? bed.exactAriaLabel : bed.rangeAriaLabel,
    }));
  }, [state.isExact]);

  return (
    <S.FlexList role="group" aria-labelledby="bedroom-filter">
      {bedCategories.map((bed) => {
        return (
          <S.FlexListItem key={`bed-category-${bed.value}`}>
            <S.ToggleButton
              onClick={handleClick}
              data-option-value={bed.value}
              isPressed={state[bed.value] === true}
              ariaPressed={state[bed.value] === true}
              ariaLabel={bed.ariaLabel}
            >
              {bed.display}
            </S.ToggleButton>
          </S.FlexListItem>
        );
      })}
    </S.FlexList>
  );
};

export default BedButtons;
